import { AnimatePresence, motion } from 'framer-motion';
import { useToast } from '../stores/toast.js';

const TONE_STYLES: Record<string, { bg: string; border: string; text: string }> = {
  info: {
    bg: 'color-mix(in oklab, var(--color-felt-deep) 90%, transparent)',
    border: 'color-mix(in oklab, var(--color-gold) 50%, transparent)',
    text: 'var(--color-ivory)',
  },
  success: {
    bg: 'color-mix(in oklab, var(--color-felt-deep) 90%, transparent)',
    border: 'var(--color-gold)',
    text: 'var(--color-gold)',
  },
  error: {
    bg: 'color-mix(in oklab, var(--color-felt-deep) 90%, transparent)',
    border: 'color-mix(in oklab, var(--color-coral) 60%, transparent)',
    text: 'var(--color-coral)',
  },
};

export function Toaster() {
  const items = useToast((s) => s.items);
  const dismiss = useToast((s) => s.dismiss);
  return (
    <div className="pointer-events-none fixed inset-x-0 top-2 z-50 mx-auto flex max-w-[420px] flex-col gap-2 px-4">
      <AnimatePresence>
        {items.map((t) => {
          const tone = TONE_STYLES[t.tone];
          if (!tone) return null;
          return (
            <motion.button
              key={t.id}
              initial={{ y: -20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -20, opacity: 0 }}
              transition={{ duration: 0.22 }}
              onClick={() => dismiss(t.id)}
              className="pointer-events-auto rounded-full px-4 py-2 text-left text-sm backdrop-blur-md"
              style={{
                background: tone.bg,
                border: `1px solid ${tone.border}`,
                color: tone.text,
              }}
            >
              {t.message}
            </motion.button>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
